import styled from 'styled-components';

export const NotFoundPageContainer = styled.main`
    &#p-not-found {
        margin-top: 40px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/notfound/NotFoundPageStyle.js